export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Luxury%20Macau%20casino%20entertainment%20complex%20at%20night%20with%20golden%20warm%20illumination%2C%20grand%20architecture%20with%20elegant%20lighting%2C%20luxurious%20atmosphere%2C%20dramatic%20sky%20with%20deep%20warm%20tones%2C%20premium%20lifestyle%20aesthetic%2C%20cinematic%20wide%20shot%2C%20no%20people%2C%20architectural%20photography%20style%20with%20soft%20glow&width=1800&height=800&seq=hero-bg-macau-2026&orientation=landscape"
        alt="澳门新葡京娱乐平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="animate-fade-in-down">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
            <i className="ri-shield-check-line text-primary-300 text-sm"></i>
            <span className="text-primary-200 text-sm font-medium">澳门政府合法授权 · 官方正版认证</span>
          </div>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4 animate-fade-in-up">
          澳门新葡京app
          <br />
          <span className="text-primary-400">官方正版安全畅玩</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/70 max-w-2xl mb-8 animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
          澳门顶级娱乐平台官方应用，正版安全下载，极速流畅体验，多元游戏娱乐，专属会员福利。
          立即下载，享受官方认证的高品质娱乐服务，随时随地畅玩。
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
          <a
            href="#download"
            className="px-8 py-3.5 rounded-lg text-base font-semibold whitespace-nowrap bg-accent-500 text-background-50 hover:bg-accent-600 transition-all duration-300 cursor-pointer shadow-lg shadow-accent-500/30"
          >
            <i className="ri-download-2-line mr-2"></i>
            立即下载App
          </a>
          <a
            href="#features"
            className="px-8 py-3.5 rounded-lg text-base font-medium whitespace-nowrap bg-background-50/15 text-background-50 hover:bg-background-50/25 border border-background-50/20 transition-all duration-300 cursor-pointer"
          >
            了解更多
            <i className="ri-arrow-down-line ml-2"></i>
          </a>
        </div>

        <div className="flex items-center gap-6 mt-10 animate-fade-in-up" style={{ animationDelay: '0.45s' }}>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">800+</div>
            <div className="text-xs text-background-50/50 mt-1">精品游戏</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">500万+</div>
            <div className="text-xs text-background-50/50 mt-1">注册会员</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">15年</div>
            <div className="text-xs text-background-50/50 mt-1">品牌历史</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-pulse-soft">
        <i className="ri-arrow-down-s-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}